import { FieldAccessor } from "../../accessors/FieldAccessor.js";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class FieldHelper {
  constructor(field) {
    __publicField(this, "getAccessor");
    this.getAccessor = field instanceof FieldAccessor ? field.getAccessor : field;
  }
}
export {
  FieldHelper
};
//# sourceMappingURL=FieldHelper.js.map
